import axios from "axios";
import { const_var } from "../../redux/reducers/common/stateObjects";

export function orderExtrasChangeValue(e, name, keyword, cost, drawingname, leanToDrawing = undefined) {
	return (dispatch) => {
		dispatch({
			type: "orderExtrasChangeValue",
			event: e,
			value: name,
			keyword: keyword,
			cost: cost,
			drawingname: drawingname,
			leanToDrawing: leanToDrawing
		});
	};
}
export function handleShowExtras(key) {
	return {
		type: "handleShowExtras",
		key: key
	};
}

export function handleShowCapture(e) {
	return {
		type: "handleShowCapture",
		value: e
	};
}
export function captureBlobImages(e) {
	return (dispatch) => {
		dispatch({
			type: "captureBlobImages",
			event: e
		});
	};
}
export function isAllCaptured(e) {
	return (dispatch) => {
		dispatch({
			type: "isAllCaptured",
			value: e
		});
	};
}
export function onClickshowhideleftpanel(e) {
	return (dispatch) => {
		dispatch({
			type: "onClickshowhideleftpanel",
			event: e
		});
	};
}
export function showImageEditor(e, value, flag, key) {
	return (dispatch) => {
		dispatch({
			type: "showImageEditor",
			event: e,
			value: value,
			flag: flag,
			key: key
		});
	};
}
export function addSluginToBlobImages(e, key, label, extrakey) {
	return (dispatch) => {
		dispatch({
			type: "addSluginToBlobImages",
			event: e,
			key: key,
			label: label,
			newKey: extrakey
		});
	};
}
export function CheckCaptureModalImage(str, key) {
	return (dispatch) => {
		dispatch({
			type: "CheckCaptureModalImage",
			str: str == "open" ? true : false,
			key: key
		});
	};
}

export const addAdditionalCharge = (key, value, index) => {
	return (dispatch) => {
		dispatch({
			type: "addAdditionalCharge",
			key: key,
			value: value,
			index: index
		});
	};
};

export const updateOrderExtraItems = (updatedData) => {
	return (dispatch) => {
		dispatch({
			type: "UpdateState",
			value: updatedData
		});
	};
};
export function handleOverhang(e, isfor, condition, nextVal, index, indexName, checkIndex, extraObjectForOverhangCalculation) {
	let overHangSize = const_var.isOverhang[isfor]["size"];
	let nextValWithSize = nextVal.find((obj) => obj.sheet_name.includes(overHangSize)) ?? nextVal[0];

	if (extraObjectForOverhangCalculation?.forDummy && extraObjectForOverhangCalculation?.nextVal?.length) {
		extraObjectForOverhangCalculation.nextVal.forEach((instance) => {
			if (instance?.d?.length === 0) {
				instance.d = undefined;
			} else {
				instance.d = instance.d.find((obj) => obj.sheet_name.includes(overHangSize)) ?? instance.d[0];
			}
		});
	}

	return (dispatch) => {
		dispatch({
			type: "handleOverhang",
			value: e,
			isfor: isfor
		});
		dispatch({
			type: "EXTRAELEMENTS",
			value: e,
			condition: condition,
			nextVal: nextValWithSize,
			index: index,
			indexName: indexName,
			checkIndex: checkIndex,
			extraObjectForOverhangCalculation: extraObjectForOverhangCalculation
		});
	};
}

export function handleOverhangSel(e, isfor, condition, nextVal, index, indexName, checkIndex, extraObjectForOverhangCalculation) {
	let overHangSize = const_var.isOverhang[isfor]["size"];
	let nextValWithSize = nextVal.filter((obj) => obj.sheet_name.includes(e));
	nextValWithSize = nextValWithSize.length > 0 ? nextValWithSize[0] : nextVal[0];

	if (extraObjectForOverhangCalculation?.forDummy && extraObjectForOverhangCalculation?.nextVal?.length) {
		extraObjectForOverhangCalculation.nextVal.forEach((instance) => {
			if (instance?.d?.length === 0) {
				instance.d = undefined;
			} else {
				instance.d = instance.d.find((obj) => obj.sheet_name.includes(e)) ?? instance.d[0];
			}
		});
	}

	return (dispatch) => {
		dispatch({
			type: "handleOverhangSel",
			value: e,
			isfor: isfor
		});
		dispatch({
			type: "EXTRAELEMENTS",
			value: e,
			condition: condition,
			nextVal: nextValWithSize,
			index: index,
			indexName: indexName,
			checkIndex: checkIndex,
			isSelect: true,
			extraObjectForOverhangCalculation: extraObjectForOverhangCalculation
		});
	};
}